import { FC, useMemo } from 'react';

import { useGiftCsMemoCache } from '@shared/api/giftCsMemo/giftCsMemo.hook';

import { CsMemoButton } from './CsMemoButton';
import { csMemoOrderIdOf } from './csMemo.utils';

export interface CsMemoCouponCellProps {
  coupon: {
    _id: string;
    code?: string;
    seq?: number;
    fullCode?: string;
    giftOrder?: unknown;
  };
  subtitle?: string;
  /** 마지막 메모 본문 미리보기 (칸이 넓은 표에서만) */
  showPreview?: boolean;
}

/**
 * 표 한 칸짜리 CS 메모 진입점 — 쿠폰만 넘기면 된다.
 * 개수는 화면(컨테이너)이 배치로 받아둔 주문 축 캐시에서 읽고, 캐시가 없으면
 * 개수 미상으로 두었다가 메모장을 열 때 그 건만 조회한다.
 */
export const CsMemoCouponCell: FC<CsMemoCouponCellProps> = ({
  coupon,
  subtitle,
  showPreview,
}) => {
  const orderId = csMemoOrderIdOf(coupon);
  const orderMemos = useGiftCsMemoCache({ giftOrder: orderId ?? '' });

  const memos = useMemo(
    () => orderMemos?.filter((m) => m.giftCoupon === coupon._id),
    [orderMemos, coupon._id],
  );

  const label =
    coupon.fullCode ??
    (coupon.code ? `${coupon.code}${coupon.seq ? `-${coupon.seq}` : ''}` : '');

  return (
    <CsMemoButton
      target={{ giftCoupon: coupon._id }}
      title={`쿠폰 ${label} · CS 응대 메모`}
      subtitle={subtitle}
      memos={memos}
      showPreview={showPreview}
    />
  );
};
